import { GraphNodeChange } from "@features/graph/changes/graphApplyChanges"
import { graphPositionChangeHandler } from "@features/graph/handlers/graphPositionChangeHandler"
import { GraphEditMode } from "@features/graph/graphViewModel"
import { graphSelectionChangeHandler } from "@features/graph/handlers/graphSelectionChangeHandler"
import { Edge, Node, NodeChange } from "reactflow"

interface ChangeParams {
  nodeChanges: { [key: string]: GraphNodeChange }
  newNodes: boolean
}

export const graphNodeChange = (
  changes: NodeChange[],
  nodeInternals: Map<string, Node>,
  edges: Edge[],
  editMode: GraphEditMode,
  selectParentChild?: boolean,
): ChangeParams => {
  const nodeChanges: { [key: string]: GraphNodeChange } = {}
  let newNodes = false
  for (const change of changes) {
    switch (change.type) {
      case "position": {
        if (editMode === GraphEditMode.OFF) {
          break
        }
        const nodes = graphPositionChangeHandler(change, nodeInternals)
        nodes.forEach((n) => {
          nodeChanges[n.id] = n
        })
        newNodes = nodes.length > 0
        break
      }
      case "select": {
        // model start fresh if we have something selected
        if (selectParentChild) {
          // reactflow is sending deselected nodes by default when we click
          // those nodes can be part of new selection those we only add changes to those
          // that are not already added by custom selection process
          if (!change.selected && !nodeChanges[change.id]) {
            nodeChanges[change.id] = {
              id: change.id,
              selected: change.selected,
            }
            newNodes = true
          } else {
            const nodes = graphSelectionChangeHandler(change, nodeInternals, edges)
            nodes.forEach((n) => {
              if (nodeChanges[n.id]) {
                // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
                if (!nodeChanges[n.id].selected) nodeChanges[n.id] = n
              } else {
                nodeChanges[n.id] = n
              }
            })
            newNodes = nodes.length > 0
          }
        } else {
          nodeChanges[change.id] = {
            id: change.id,
            selected: change.selected,
          }
          newNodes = true
        }
        break
      }
      default:
        break
    }
  }
  return { newNodes, nodeChanges }
}
